module.exports = __webpack_public_path__ + "img/img-3-2mobile.ace868fc.png";